module.exports = __webpack_public_path__ + "static/media/Jubel-Regular.71a024ad.woff";